const elPaginationKey = Symbol("elPaginationKey");

export { elPaginationKey };
//# sourceMappingURL=constants.mjs.map
